import { storeCreator } from '@/utils/store/store.utils';

interface State {
  isApplyMode: boolean;
  selectIndexes: number[];
  currentFileId: string | null;
  currentDocumentId: string | null;

  isMultipleMode?: boolean;

  setCurrentDocumentId: (value: string | null) => void;
  setCurrentFileId: (value: string | null) => void;
  setIsMultipleMode: (value: boolean) => void;
  setApplyMode: (value: boolean) => void;
  toggleSelectedIndexes: (value: number) => void;
  handleToggle: () => void;
  reset: () => void;
}

export const useStore = storeCreator<State>((set) => ({
  isApplyMode: false,
  selectIndexes: [],
  isMultipleMode: false,
  currentFileId: null,
  currentDocumentId: null,

  setCurrentDocumentId: (value: string | null) =>
    set(() => ({
      currentDocumentId: value,
    })),
  setCurrentFileId: (value: string | null) =>
    set(() => ({
      currentFileId: value,
    })),
  setIsMultipleMode: (value: boolean) =>
    set(() => ({
      isMultipleMode: value,
    })),
  setApplyMode: (value: boolean) =>
    set(() => ({
      isApplyMode: value,
    })),
  handleToggle: () =>
    set((state) => ({
      isApplyMode: !state.isApplyMode,
    })),

  toggleSelectedIndexes: (index: number) =>
    set((state) => {
      if (state.selectIndexes.includes(index)) {
        const filtered = state.selectIndexes.filter((item) => item !== index);
        return {
          selectIndexes: filtered,
        };
      }
      return {
        selectIndexes: [...state.selectIndexes, index],
      };
    }),
  reset: () =>
    set(() => {
      return {
        selectIndexes: [],
        currentFileId: null,
        currentDocumentId: null,
      };
    }),
}));

export default useStore;
